(function () {
  function formatVariantPrice(priceCents) {
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      return window.Shopify.formatMoney(priceCents);
    }

    var euros = priceCents / 100;
    if (Math.round(euros) === euros) {
      return Math.round(euros) + ' €';
    }
    return euros.toFixed(2).replace('.', ',') + ' €';
  }

  function notifyGiftCardAmountChange() {
    document.dispatchEvent(new CustomEvent('gift-card:amount-change'));
  }

  function getAmountMap(root) {
    var mapEl = root.querySelector('[data-gift-card-amount-map]');
    if (!mapEl) return [];

    try {
      return JSON.parse(mapEl.textContent);
    } catch (error) {
      return [];
    }
  }

  function resolveMediaAmountKey(variant, amountMap) {
    var match = amountMap.find(function (item) {
      return Number(item.price) === Number(variant.price);
    });

    if (match && match.key) {
      return match.key;
    }

    var title = variant.option1 || variant.title || '';
    return title
      .toLowerCase()
      .replace(/€/g, '')
      .replace(/\s+/g, '-')
      .trim();
  }

  function bindPhysicalAmountInput(root, input) {
    input.addEventListener('change', function () {
      var errorEl = root.querySelector('[data-physical-error]');
      if (errorEl) {
        errorEl.hidden = true;
        errorEl.textContent = '';
      }
      notifyGiftCardAmountChange();
    });
  }

  function renderPhysicalAmounts(root, variants) {
    var fieldset = root.querySelector('[data-physical-amount-fieldset]');
    var loadingEl = root.querySelector('[data-physical-amounts-loading]');
    if (!fieldset || !variants || !variants.length) return false;

    var sectionId = root.getAttribute('data-section-id') || 'gift-card';
    var amountMap = getAmountMap(root);
    var html = '';
    var hasChecked = false;

    variants.forEach(function (variant) {
      var inputId = 'PhysicalGiftCard-' + sectionId + '-' + variant.id;
      var isDisabled = variant.available === false;
      var checked = !hasChecked && !isDisabled;
      var mediaAmountKey = resolveMediaAmountKey(variant, amountMap);

      if (checked) {
        hasChecked = true;
      }

      html +=
        '<div class="variant-input" data-value="' +
        String(mediaAmountKey).replace(/"/g, '&quot;') +
        '">' +
        '<input type="radio" name="physical-gift-card-amount-' +
        sectionId +
        '" id="' +
        inputId +
        '" value="' +
        variant.id +
        '" data-physical-variant-input data-variant-price="' +
        variant.price +
        '" data-media-amount-key="' +
        String(mediaAmountKey).replace(/"/g, '&quot;') +
        '"' +
        (isDisabled ? ' disabled' : '') +
        (checked ? ' checked' : '') +
        '>' +
        '<label for="' +
        inputId +
        '" class="variant__button-label' +
        (isDisabled ? ' disabled' : '') +
        '">' +
        formatVariantPrice(variant.price) +
        '</label>' +
        '</div>';
    });

    if (!html) return false;

    fieldset.innerHTML = html;

    if (!hasChecked) {
      var firstEnabled = fieldset.querySelector('[data-physical-variant-input]:not([disabled])');
      if (firstEnabled) {
        firstEnabled.checked = true;
      }
    }

    if (loadingEl) {
      loadingEl.hidden = true;
    }

    fieldset.querySelectorAll('[data-physical-variant-input]').forEach(function (input) {
      bindPhysicalAmountInput(root, input);
    });

    notifyGiftCardAmountChange();
    return true;
  }

  function loadPhysicalAmounts(root) {
    var handle = root.getAttribute('data-physical-product-handle');
    var fieldset = root.querySelector('[data-physical-amount-fieldset]');
    var loadingEl = root.querySelector('[data-physical-amounts-loading]');

    if (!handle || !fieldset) return Promise.resolve(false);

    if (fieldset.querySelector('[data-physical-variant-input]')) {
      if (loadingEl) loadingEl.hidden = true;
      return Promise.resolve(true);
    }

    if (loadingEl) {
      loadingEl.hidden = false;
    }

    var rootUrl = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/';

    return fetch(rootUrl + 'products/' + encodeURIComponent(handle) + '.js')
      .then(function (response) {
        if (!response.ok) {
          throw new Error('Produit physique introuvable.');
        }
        return response.json();
      })
      .then(function (product) {
        return renderPhysicalAmounts(root, product.variants || []);
      })
      .catch(function () {
        if (loadingEl) {
          loadingEl.hidden = false;
          loadingEl.textContent = 'Impossible de charger les montants. Veuillez réessayer.';
        }
        return false;
      });
  }

  function initGiftCardDelivery(root) {
    if (!root || root.dataset.giftCardDeliveryInit === 'true') return;
    root.dataset.giftCardDeliveryInit = 'true';

    var digitalContent = root.parentElement
      ? root.parentElement.querySelector('[data-giftcard-digital-content]')
      : document.querySelector('[data-giftcard-digital-content]');
    var physicalPanel = root.querySelector('[data-gift-card-panel="physical"]');
    var tabs = document.querySelectorAll('[data-gift-card-tab]');
    var hasPhysical = root.getAttribute('data-has-physical') === 'true' && !!physicalPanel && tabs.length > 0;
    var addButton = root.querySelector('[data-physical-add-to-cart]');
    var errorEl = root.querySelector('[data-physical-error]');
    var shipToggle = root.querySelector('[data-physical-ship-recipient]');
    var recipientFields = root.querySelector('[data-physical-recipient-fields]');
    var senderLastInput = root.querySelector('[data-physical-sender-last-input]');
    var senderFirstInput = root.querySelector('[data-physical-sender-first-input]');
    var recipientLastInput = root.querySelector('[data-physical-recipient-last-input]');
    var recipientFirstInput = root.querySelector('[data-physical-recipient-first-input]');
    var addressInput = root.querySelector('[data-physical-address-input]');
    var zipInput = root.querySelector('[data-physical-zip-input]');
    var cityInput = root.querySelector('[data-physical-city-input]');
    var qtyInput = root.querySelector('[data-physical-qty-input]');
    var qtyMinus = root.querySelector('[data-physical-qty-minus]');
    var qtyPlus = root.querySelector('[data-physical-qty-plus]');
    var clickCollect = document.querySelector('[data-store-availability-holder]');
    var recipientFormInputs = [
      senderLastInput,
      senderFirstInput,
      recipientLastInput,
      recipientFirstInput,
      addressInput,
      zipInput,
      cityInput
    ];

    if (!digitalContent) return;

    if (hasPhysical) {
      loadPhysicalAmounts(root);

      root.querySelectorAll('[data-physical-variant-input]').forEach(function (input) {
        bindPhysicalAmountInput(root, input);
      });
    }

    function setError(message) {
      if (!errorEl) return;
      if (!message) {
        errorEl.hidden = true;
        errorEl.textContent = '';
        return;
      }
      errorEl.hidden = false;
      errorEl.textContent = message;
    }

    function getSelectedVariantId() {
      var checked = root.querySelector('[data-physical-variant-input]:checked:not([disabled])');
      return checked ? checked.value : null;
    }

    function shipsToRecipient() {
      return !!(shipToggle && shipToggle.checked);
    }

    function syncRecipientFields() {
      if (!recipientFields) return;
      var show = shipsToRecipient();
      recipientFields.hidden = !show;
      recipientFormInputs.forEach(function (input) {
        if (!input) return;
        if (show) {
          input.setAttribute('required', 'required');
        } else {
          input.removeAttribute('required');
        }
      });
    }

    function getQuantity() {
      if (!qtyInput) return 1;
      var qty = parseInt(qtyInput.value, 10);
      if (isNaN(qty) || qty < 1) return 1;
      return qty;
    }

    function setQuantity(value) {
      if (!qtyInput) return;
      var qty = parseInt(value, 10);
      if (isNaN(qty) || qty < 1) qty = 1;
      qtyInput.value = String(qty);
    }

    function setIntroMode(mode) {
      root.querySelectorAll('[data-gift-card-intro]').forEach(function (intro) {
        var introMode = intro.getAttribute('data-gift-card-intro');
        intro.hidden = introMode !== mode;
      });
    }

    function setMode(mode) {
      if (!hasPhysical) {
        mode = 'digital';
      }

      var isPhysical = mode === 'physical';

      setIntroMode(mode);

      tabs.forEach(function (tab) {
        var active = tab.getAttribute('data-gift-card-tab') === mode;
        tab.classList.toggle('is-active', active);
        tab.setAttribute('aria-selected', active ? 'true' : 'false');
      });

      if (physicalPanel) {
        physicalPanel.hidden = !isPhysical;
      }

      digitalContent.hidden = isPhysical;
      digitalContent.setAttribute('aria-hidden', isPhysical ? 'true' : 'false');

      if (clickCollect) {
        clickCollect.hidden = isPhysical;
      }

      if (isPhysical && hasPhysical) {
        syncRecipientFields();
        loadPhysicalAmounts(root).then(function () {
          notifyGiftCardAmountChange();
        });
      } else {
        notifyGiftCardAmountChange();
      }

      setError('');
    }

    if (hasPhysical) {
      tabs.forEach(function (tab) {
        tab.addEventListener('click', function () {
          setMode(tab.getAttribute('data-gift-card-tab'));
        });
      });
    }

    if (shipToggle) {
      shipToggle.addEventListener('change', function () {
        syncRecipientFields();
        setError('');
      });
      syncRecipientFields();
    }

    if (qtyMinus) {
      qtyMinus.addEventListener('click', function () {
        setQuantity(getQuantity() - 1);
      });
    }

    if (qtyPlus) {
      qtyPlus.addEventListener('click', function () {
        setQuantity(getQuantity() + 1);
      });
    }

    if (qtyInput) {
      qtyInput.addEventListener('change', function () {
        setQuantity(qtyInput.value);
      });
    }

    function validatePhysicalForm() {
      var variantId = getSelectedVariantId();

      if (!variantId) {
        return 'Veuillez sélectionner un montant.';
      }

      if (!shipsToRecipient()) {
        return '';
      }

      var senderLast = senderLastInput ? senderLastInput.value.trim() : '';
      var senderFirst = senderFirstInput ? senderFirstInput.value.trim() : '';
      var lastName = recipientLastInput ? recipientLastInput.value.trim() : '';
      var firstName = recipientFirstInput ? recipientFirstInput.value.trim() : '';
      var address = addressInput ? addressInput.value.trim() : '';
      var zip = zipInput ? zipInput.value.trim() : '';
      var city = cityInput ? cityInput.value.trim() : '';

      if (!senderLast) {
        return 'Veuillez indiquer le nom de la personne qui offre.';
      }
      if (!senderFirst) {
        return 'Veuillez indiquer le prénom de la personne qui offre.';
      }
      if (!lastName) {
        return 'Veuillez indiquer le nom du bénéficiaire.';
      }
      if (!firstName) {
        return 'Veuillez indiquer le prénom du bénéficiaire.';
      }
      if (!address || !zip || !city) {
        return "Veuillez renseigner l'adresse d'expédition complète.";
      }
      return '';
    }

    function openCartDrawer() {
      if (window.theme && window.theme.CartDrawer) {
        var drawer = new window.theme.CartDrawer();
        drawer.init();
        drawer.open();
        return;
      }
      window.location.href = (window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') + 'cart';
    }

    if (hasPhysical && addButton) {
      addButton.addEventListener('click', function () {
        loadPhysicalAmounts(root).then(function () {
          var validationError = validatePhysicalForm();
          if (validationError) {
            setError(validationError);
            return;
          }

          setError('');
          addButton.classList.add('btn--loading');
          addButton.disabled = true;

          var properties = {
            'Type de carte': 'Physique'
          };

          if (shipsToRecipient()) {
            properties['Envoi destinataire'] = 'Oui';
            properties['Expédition'] = 'Destinataire (autre que acheteur)';
            properties['Nom de la personne qui offre'] = senderLastInput.value.trim();
            properties['Prénom de la personne qui offre'] = senderFirstInput.value.trim();
            properties['Nom du bénéficiaire'] = recipientLastInput.value.trim();
            properties['Prénom du bénéficiaire'] = recipientFirstInput.value.trim();
            properties.Adresse = addressInput.value.trim();
            properties['Code postal'] = zipInput.value.trim();
            properties.Ville = cityInput.value.trim();
          } else {
            properties['Envoi destinataire'] = 'Non';
            properties['Expédition'] = "À l'acheteur";
          }

          fetch((window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') + 'cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              items: [
                {
                  id: Number(getSelectedVariantId()),
                  quantity: getQuantity(),
                  properties: properties
                }
              ]
            })
          })
            .then(function (response) {
              return response.json().then(function (data) {
                if (!response.ok) {
                  throw new Error(data.description || data.message || "Erreur lors de l'ajout au panier.");
                }
                return data;
              });
            })
            .then(function () {
              document.dispatchEvent(new CustomEvent('cart:refresh'));
              openCartDrawer();
            })
            .catch(function (error) {
              setError(error.message || 'Une erreur est survenue. Veuillez réessayer.');
            })
            .finally(function () {
              addButton.classList.remove('btn--loading');
              addButton.disabled = false;
            });
        });
      });
    }

    if (hasPhysical) {
      recipientFormInputs.forEach(function (input) {
        if (!input) return;
        input.addEventListener('input', function () {
          setError('');
        });
      });
    }

    setMode('digital');
  }

  function boot() {
    document.querySelectorAll('[data-gift-card-delivery]').forEach(initGiftCardDelivery);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
